module.exports = __webpack_public_path__ + "img/icon_map_2_off_010.62af4209.png";